/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PutResponse } from '../../models/put-response';

export interface StoresStoreIdPosConfigPut$Params {
  'Active-Tenant-Identifier': string;
  'source-store': string;
  'source-tenant': string;
  storeId: string;
}

export function storesStoreIdPosConfigPut(http: HttpClient, rootUrl: string, params: StoresStoreIdPosConfigPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdPosConfigPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.header('source-store', params['source-store'], {});
    rb.header('source-tenant', params['source-tenant'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PutResponse>;
    })
  );
}

storesStoreIdPosConfigPut.PATH = '/stores/{storeId}/pos-config';
